export const data = [
  {
    id: 0,
    category: 'Apartamento',
    value: 'R$ 1.000.000,00',
    status: 'Em processamento',
    categoryName: 'Consórcio Genial',
    adminTax: '24%',
    monthlyValue: 'R$ 5.662,10',
    paymentsAmount: 219,
    operations: [
      {
        id: 0,
        date: '09 jul 2024',
        type: 'Solicitação',
      },
    ],
  },
  {
    id: 1,
    category: 'Carro',
    value: 'R$ 80.000,00',
    status: 'Ativo',
    categoryName: 'Consórcio Automotivo',
    adminTax: '20%',
    monthlyValue: 'R$ 1.200,00',
    paymentsAmount: 60,
    operations: [
      {
        id: 0,
        date: '15 mar 2023',
        type: 'Adesão',
      },
      {
        id: 1,
        date: '20 abr 2023',
        type: 'Pagamento',
      },
    ],
  },
  {
    id: 2,
    category: 'Imóvel',
    value: 'R$ 500.000,00',
    status: 'Contemplado',
    categoryName: 'Consórcio Imobiliário Plus',
    adminTax: '22%',
    monthlyValue: 'R$ 3.500,00',
    paymentsAmount: 180,
    operations: [
      {
        id: 0,
        date: '10 jan 2022',
        type: 'Adesão',
      },
      {
        id: 1,
        date: '05 dez 2023',
        type: 'Contemplação',
      },
    ],
  },
  {
    id: 3,
    category: 'Moto',
    value: 'R$ 25.000,00',
    status: 'Em andamento',
    categoryName: 'Consórcio Duas Rodas',
    adminTax: '18%',
    monthlyValue: 'R$ 450,00',
    paymentsAmount: 48,
    operations: [
      {
        id: 0,
        date: '03 jun 2023',
        type: 'Adesão',
      },
    ],
  },
  {
    id: 4,
    category: 'Reforma',
    value: 'R$ 150.000,00',
    status: 'Aguardando aprovação',
    categoryName: 'Consórcio Reforma Fácil',
    adminTax: '21%',
    monthlyValue: 'R$ 1.800,00',
    paymentsAmount: 100,
    operations: [
      {
        id: 0,
        date: '12 mai 2024',
        type: 'Solicitação',
      },
    ],
  },
];
